<template>
  <v-card class="table-container">
    <div
      v-if="useSearchWorkspaceList"
      class="pl-6">
      Total Workspaces: {{ items.length }}
      <v-progress-circular
        v-if="!isLoadedWsList"
        style="margin-bottom: 2px;"
        :size="14"
        color="lightBlue"
        indeterminate />
    </div>
    <v-data-table
      :items="useSearchWorkspaceList ? filteredWorkspacesList : items"
      :headers="headers"
      must-sort
      fixed-header
      calculate-widths
      :height="renderTableHeight"
      :items-per-page="-1"
      class="v-data-table--listing elevation-1 pa-6 v-data-table--workspaces"
      hide-default-footer>
      <template
        v-if="useSearchWorkspaceList"
        #top>
        <app-search-rows-input
          :items="items"
          placeholder="Search for workspaces"
          :search-for="['name', {
            creator: ['name'],
          }]"
          @found-items="filteredWorkspacesList = $event" />
      </template>
      <template
        v-slot:[`item.action`]="{ item }">
        <v-menu
          offset-y
          nudge-left="200"
          content-class="edit-menu"
          :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              @click="$store.commit('changeOpenedDetailForUser', item.id)">
              <v-icon
                medium
                color="mainGrey"
                class="brightness-icon">
                mdi-dots-vertical
              </v-icon>
            </span>
          </template>
          <v-card class="nav-card">
            <p
              class="small-p"
              @click="$emit('onManageWorkspace' , item)">
              <v-icon
                small
                class="mr-2">
                mdi-group
              </v-icon>
              Manage Workspace
            </p>
          </v-card>
        </v-menu>
      </template>
      <template
        v-slot:[`item.name`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div
              :id="setLastWorkspaceId(item.id)"
              v-intersect="onIntersect"
              class="table-col"
              v-on="on">
              {{ item.name.length > 30 ? item.name.slice(0, 30) + '...' : item.name }}
              <v-icon
                v-if="item.verified"
                color="lightBlue">
                mdi-checkbox-marked-circle
              </v-icon>
            </div>
          </template>
          <span>
            {{ item.name }}
          </span>
        </v-tooltip>
      </template>
      <template
        v-slot:[`item.allowPages`]="{ item }">
        <v-icon class="pages-icon">
          {{ item.allowPages ? 'mdi-check' : 'mdi-minus' }}
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import AppSearchRowsInput from '@/components/App/AppSearchRowsInput';
import { mapGetters } from 'vuex';
export default {
  name: 'WorkspacesTable',
  components: {
    AppSearchRowsInput,
  },
  props: {
    isLoadedWsList: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: ()=>[],
    },
    headers: {
      type: Array,
      default: ()=>[],
    },
    nextToken: {
      type: String || Object,
      default: ()=>'',
    },
  },
  data() {
    return {
      filteredWorkspacesList: [],
    };
  },
  computed: {
    ...mapGetters('SiteConfiguration', ['useSearchWorkspaceList']),
    renderTableHeight() {
      if (this.$vuetify.breakpoint.xs) {
        return window.innerHeight - 403;
      }
      return window.innerHeight - 310;
    },
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      if (this.useSearchWorkspaceList) return;
      if (isIntersecting) {
        const workspace = entries[0].target.id;
        if (this.nextToken && workspace && workspace === 'last-workspace') {
          this.$emit('getWorkspaces');
        }
      }
    },
    setLastWorkspaceId(id) {
      const { items } = this;
      if (id === items[items.length - 1].id) {
        return 'last-workspace';
      } return null;
    },
  },
};
</script>
<style scoped lang="scss">
.table-container{
  margin-top: 75px;
  padding-top: 24px;
  .pages-icon {
    &::before {
      font-weight: 700;
    }
  }
}
</style>
